// Token-free signal for the KinShield browser extension's content script
// (apps/browser-extension/src/content/authBridge.js), which re-mints its scoped
// token when it hears this. Never put credentials or user data in the event.
export const AUTH_CHANGED_EVENT = "kinshield:auth-changed";

export const notifyAuthChanged = () => {
  try {
    window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
  } catch {
    /* non-browser environment */
  }
};
